// extracted by mini-css-extract-plugin
module.exports = {"containerPhone":"styles_containerPhone__PT0y4"};